import PrivacyContent from "./privacy_content";
import markdown from "@syntensor/common/_content/privacy/cookies.md";

export default function PrivacyCookies() {
  return <PrivacyContent markdown={markdown} />;
}
